<template>
    <div class="form form-horizontal">
        <h4>Historic Artifacts</h4>
        <div v-for="category in artifactCategoryList" class="col-md-2" :key="category.index">
            <label>{{category.description}}</label>
            <ul type="none" style="padding-left:0px">
                <li v-for="artifact in artifactList.filter(x => {return x.artifactCategoryId === category.artifactCategoryId})" :key="artifact.artifactId">
                    <div class="checkbox checkbox-inline">
                        <input type="checkbox" v-model="selectedList" v-bind:id="artifact.artifactId" v-bind:value="artifact.artifactId">
                            <label v-bind:for="artifact.artifactId">{{ artifact.description }}</label>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import loggingService from '@/services/util/loggingService'
import artifactService from '@/services/lookup/artifactService'

export default {
    name: 'historicArtifactSelection',
    components: {

    },
    mounted () {
        Promise.resolve(this.loadData()).then(result => {
            this.log('load is done')
        })
    },
    data: function () {
        return {
            isDebug: false,
            artifactList: [],
            artifactCategoryList: [],
            selectedList: []
        }
    },
    computed: {
        filteredSelectedList: function () {
            return this.selectedList.filter(x => {
                return this.artifactList.find(y => y.artifactId === x && y.timePeriodId === 3)
            })
        }
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Historic Artifact Selection', message)
        },
        loadData () {
            artifactService.listArtifact(this.$http).then(result => {
                this.artifactList = result.data.filter(x => {
                    return x.timePeriodId === 3
                })
            })
            artifactService.listArtifactCategory(this.$http).then(result => {
                this.artifactCategoryList = result.data.filter(x => {
                    return (x.artifactCategoryId >= 7 && x.artifactCategoryId <= 11)
                })
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// HistoricArtifactSelection.vue?3bc89169